export default __webpack_public_path__ + "static/media/Car_Lora_Thumb_G-Wagon.d02fcea7.jpg";